module.exports = __webpack_public_path__ + "img/2019homepark-6.eeab80a4.jpeg";